import { render, staticRenderFns } from "./ManageGroupTeacher.vue?vue&type=template&id=7fb24a9e&scoped=true"
import script from "./ManageGroupTeacher.vue?vue&type=script&lang=js"
export * from "./ManageGroupTeacher.vue?vue&type=script&lang=js"
import style0 from "./ManageGroupTeacher.vue?vue&type=style&index=0&id=7fb24a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb24a9e",
  null
  
)

export default component.exports